import { Component, inject } from '@angular/core';
import { TileCreatorService } from '../../services/tile-creator.service';
import { TILE_REQUEST } from '../../tokens/tile-request.token';

@Component({
  standalone: true,
  selector: 'analytics-heatmap-custom-component-setup-wizard',
  template: '',
})
export class AnalyticsHeatmapCustomComponentSetupWizardComponent {
  constructor(tileCreatorService: TileCreatorService) {
    const tileDefinition = inject(TILE_REQUEST).tileInstance;
    tileDefinition.tileType = 'analytics-heatmap-custom-component';
    tileCreatorService.onChange.next();
  }
}
